import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VCurrencyField from "v-currency-field";
import { VTextField } from "vuetify/lib"; //Globally import VTextField

import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
// import "floating-vue/dist/style.css";
import "./assets/css/main.css";

import "./plugins/vuetify-mask.js";

Vue.config.productionTip = false;

// Vue.use(FloatingVue);

Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField, {
  locale: "pt-BR",
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true,
});

Vue.filter("datetimeFormatBr", function (value) {
  if (!value) return "";
  let [date, hours] = value.split(" ");
  date = date.split("-").reverse().join("/");
  return `${date} ${hours}`;
});

Vue.filter("dateFormatBr", function (value) {
  if (!value) return "";
  return value.split("-").reverse().join("/");
});

Vue.filter("dateFormatEua", function (value) {
  if (!value) return "";
  return value.split("/").reverse().join("-");
});

Vue.filter("currencyEuaToBr", function (value) {
  if (!value) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
